import React from 'react';
import CheckCircleOn from '../../../images/check-circle-on.svg';
import CheckCircleOff from '../../../images/check-circle-off.svg';
import classes from './SubscriptionRow.module.scss';

const SubscriptionRowInfo = ({ title, tick1 }) => {
	return (
		<div className={classes.row}>
			<div className={classes.column}>
				<div className={classes.columnHeader}>{title}</div>
			</div>
			{[tick1].map((tick, index) => (
				<div key={index} className={classes.column}>
					<div className={classes.iconContainer}>
						<img
							src={tick ? CheckCircleOn : CheckCircleOff}
							alt='CheckIcon'
							className={classes.checkIcon}
						/>
					</div>
				</div>
			))}
		</div>
	);
};

export default SubscriptionRowInfo;
